import React from 'react'
import VirtualCardDetail from 'src/app/VirtualCardDetail/VirtualCardDetail'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import VirtualCardsNeedsApprovalAppRoute from 'src/navigation/appRoutes/virtualCards/virtualCardsNeedsApproval.appRoute'
import VirtualCardsRequestsAppRoute from 'src/navigation/appRoutes/virtualCards/virtualCardsRequests.appRoute'
import {
  virtualCardDetailRouteProps,
  virtualCardsYourCardsRouteProps,
  yourCardsActiveRouteProps,
  yourCardsInactiveRouteProps,
  yourCardsRouteProps,
} from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'
import VirtualCardsAllCardsAppRoute from './virtualCards/virtualCardsAllCards.appRoute'

// No component: these exact legacy /virtualcards/* paths have none. Listed
// only so they keep falling through to NotFound instead of being swallowed
// by this route's :id match.
const legacyYourCardsRouteExceptions: Array<
  Pick<AppRoute, 'routeProps' | 'subRoutes'>
> = [
  { routeProps: yourCardsRouteProps, subRoutes: [] },
  { routeProps: yourCardsActiveRouteProps, subRoutes: [] },
  { routeProps: yourCardsInactiveRouteProps, subRoutes: [] },
  { routeProps: virtualCardsYourCardsRouteProps, subRoutes: [] },
]

const VirtualCardDetailAppRoute: AppRoute = {
  id: AppLocation.VirtualCardDetail,
  routeProps: virtualCardDetailRouteProps,
  component: <VirtualCardDetail />,
  subRoutes: [],
  exceptions: [
    VirtualCardsAllCardsAppRoute,
    VirtualCardsRequestsAppRoute,
    VirtualCardsNeedsApprovalAppRoute,
    ...legacyYourCardsRouteExceptions,
  ],
  meta: { contentType: SidenavContentType.Main },
}

export default VirtualCardDetailAppRoute
